import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { CourseExportDetail } from '../../../../pages/course-export/CourseExportDetail';
import { RoutePending } from '../../../../components/molecules/loader/RoutePending';
import { courseExportDetailParamsSchema } from '../../../../routing/schemas';
import { getCourseExportDetailQueryOptions } from '../../../../pages/course-export/components/CourseExportDetail.queries';
import { getListTagsQueryOptions } from '../../../../pages/project/components/ProjectsCore.queries';

export const Route = createFileRoute('/_private/_home/course-exports/$course_version_guid')({
  params: {
    parse: (rawParams) => courseExportDetailParamsSchema.parse(rawParams),
    stringify: (params) => params,
  },
  loader: ({ context, params }) => {
    void context.queryClient.prefetchQuery(
      getCourseExportDetailQueryOptions(context.apiClient, params.course_version_guid)
    );
    void context.queryClient.prefetchQuery(getListTagsQueryOptions(context.apiClient));
  },
  component: CourseExportDetailRoute,
  pendingComponent: () => <RoutePending label="Loading dispatch versions..." />,
});

function CourseExportDetailRoute() {
  const { apiClient } = Route.useRouteContext();
  return <CourseExportDetail portalApiClient={apiClient} />;
}
